function getGaTrackingId() {
    return `${window.GoogleAnalyticsCode()}`;
}

export function InitialiseGoogleUA() {
    try {
        // var path = window.location.href;
        (function(i, s, o, g, r, a, m) {
            i.GoogleAnalyticsObject = r;
            i[r] = i[r] || function() {
                (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * new Date();
            a = s.createElement(o),
                m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        }(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga'));

        ga('create', getGaTrackingId(), 'auto', {
            //appName: 'QueueView',
            appName: 'TicketTrackingView',
            siteSpeedSampleRate: 50
        });
        // ga('send', 'pageview', path);
        ga('send', 'pageview');
    } catch (e) {
        console.log(e);
    }
}

export function SendEventToGA(eventCategory, eventAction, eventLabel, eventValue) {
    try {
        ga('send', 'event', eventCategory, eventAction, eventLabel, eventValue);
    } catch (e) {
        console.log(e);
    }
}



// WEBPACK FOOTER //
// ./app/common/googleAnalytics.js